<template>
  <div>
    <div class="call-page-container">
      <div v-if="pageLoading" class="text-center" style="padding: 80px 0">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Carregando...</span>
        </div>
        <p class="mt-2">Carregando chamados...</p>
      </div>

      <template v-else>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <h3 class="mb-0">Chamados</h3>
          <router-link :to="endPoint + 'add'" class="btn btn-primary"
            >Novo chamado</router-link
          >
        </div>

        <!-- KPIs — visível apenas para admin (perfil_id = 8) -->
        <div v-if="isAdmin" class="row mb-2">
          <div class="col-md-12">
            <div class="d-flex flex-wrap" style="gap: 10px">
              <div
                class="card px-3 py-2 text-center kpi-card"
                style="min-width: 130px; flex: 1; cursor: pointer"
                :class="{ 'kpi-active': kpiFilters.length === 0 }"
                @click="clearKpis()"
                title="Mostrar todos"
              >
                <div
                  class="text-muted kpi-card"
                  style="
                    font-size: 12px;
                    font-weight: 600;
                    text-transform: uppercase;
                  "
                >
                  Total Abertos
                </div>
                <div class="font-weight-bold" style="font-size: 28px">
                  {{ kpis.total !== undefined ? kpis.total : "—" }}
                </div>
              </div>
              <div
                class="card px-3 py-2 text-center kpi-card"
                style="min-width: 130px; flex: 1; cursor: pointer"
                :class="{ 'kpi-active': kpiFilters.includes('aguardando') }"
                @click="toggleKpiFilter('aguardando')"
                title="Filtrar: Aguardando Atendimento"
              >
                <div
                  class="text-muted kpi-card"
                  style="
                    font-size: 12px;
                    font-weight: 600;
                    text-transform: uppercase;
                  "
                >
                  Aguardando Atend.
                </div>
                <div
                  class="font-weight-bold text-danger"
                  style="font-size: 28px"
                >
                  {{ kpis.aguardando !== undefined ? kpis.aguardando : "—" }}
                </div>
              </div>
              <div
                class="card px-3 py-2 text-center kpi-card"
                style="min-width: 130px; flex: 1; cursor: pointer"
                :class="{
                  'kpi-active': kpiFilters.includes('com_release'),
                  'kpi-disabled': kpiFilters.includes('sem_release'),
                }"
                @click="
                  !kpiFilters.includes('sem_release') &&
                    toggleKpiFilter('com_release')
                "
                title="Filtrar: Em Release"
              >
                <div
                  class="text-muted kpi-card"
                  style="
                    font-size: 12px;
                    font-weight: 600;
                    text-transform: uppercase;
                  "
                >
                  Em Release
                </div>
                <div
                  class="font-weight-bold text-primary"
                  style="font-size: 28px"
                >
                  {{ kpis.com_release !== undefined ? kpis.com_release : "—" }}
                </div>
              </div>
              <div
                class="card px-3 py-2 text-center kpi-card"
                style="min-width: 130px; flex: 1; cursor: pointer"
                :class="{
                  'kpi-active': kpiFilters.includes('sem_release'),
                  'kpi-disabled': kpiFilters.includes('com_release'),
                }"
                @click="
                  !kpiFilters.includes('com_release') &&
                    toggleKpiFilter('sem_release')
                "
                title="Filtrar: Sem Release"
              >
                <div
                  class="text-muted"
                  style="
                    font-size: 12px;
                    font-weight: 600;
                    text-transform: uppercase;
                  "
                >
                  Sem Release
                </div>
                <div
                  class="font-weight-bold text-warning"
                  style="font-size: 28px"
                >
                  {{ kpis.sem_release !== undefined ? kpis.sem_release : "—" }}
                </div>
              </div>
              <div
                class="card px-3 py-2 text-center kpi-card"
                style="min-width: 130px; flex: 1; cursor: pointer"
                :class="{ 'kpi-active': kpiFilters.includes('tipo_erro') }"
                @click="toggleKpiFilter('tipo_erro')"
                title="Filtrar: Tipo Erro"
              >
                <div
                  class="text-muted"
                  style="
                    font-size: 12px;
                    font-weight: 600;
                    text-transform: uppercase;
                  "
                >
                  Tipo Erro
                </div>
                <div
                  class="font-weight-bold text-danger"
                  style="font-size: 28px"
                >
                  {{ kpis.tipo_erro !== undefined ? kpis.tipo_erro : "—" }}
                </div>
              </div>
              <div
                class="card px-3 py-2 text-center kpi-card"
                style="min-width: 130px; flex: 1; cursor: pointer"
                :class="{ 'kpi-active': kpiFilters.includes('tipo_melhoria') }"
                @click="toggleKpiFilter('tipo_melhoria')"
                title="Filtrar: Tipo Melhoria"
              >
                <div
                  class="text-muted"
                  style="
                    font-size: 12px;
                    font-weight: 600;
                    text-transform: uppercase;
                  "
                >
                  Tipo<br />Melhoria
                </div>
                <div
                  class="font-weight-bold text-success"
                  style="font-size: 28px"
                >
                  {{
                    kpis.tipo_melhoria !== undefined ? kpis.tipo_melhoria : "—"
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card call-filters">
          <button
            type="button"
            class="btn-filters-toggle d-md-none"
            @click="filtersOpen = !filtersOpen"
          >
            <span>Filtros</span>
            <span class="chevron" :class="{ open: filtersOpen }">▾</span>
          </button>
          <div
            class="card-body"
            :class="{ 'card-body-mobile-open': filtersOpen }"
          >
            <div class="row">
              <div class="col-md-2">
                <label>ID</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filters.id"
                  placeholder="Nº do chamado"
                />
              </div>
              <div class="col-md-4">
                <label>Título</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filters.title"
                  placeholder="Buscar por título..."
                />
              </div>
              <div class="col-md-3">
                <label>Status</label>
                <v-select
                  v-model="filters.status"
                  :options="status_calls"
                  :reduce="(s) => s.status"
                  label="description"
                  placeholder="Selecione"
                ></v-select>
              </div>
              <div class="col-md-3">
                <label>Solicitante</label>
                <v-select
                  v-model="filters.user_id"
                  :options="users"
                  :reduce="(u) => u.id"
                  label="text"
                  placeholder="Selecione"
                ></v-select>
              </div>
              <div class="col-md-3 mt-2">
                <label>Pessoa responsável</label>
                <v-select
                  v-model="filters.dev_acting"
                  :options="users"
                  :reduce="(u) => u.id"
                  label="text"
                  placeholder="Selecione"
                ></v-select>
              </div>
              <div class="col-md-3 mt-2">
                <label>Prioridade</label>
                <v-select
                  v-model="filters.priority"
                  :options="priorityOptions"
                  :reduce="(p) => p.id"
                  label="text"
                  placeholder="Selecione"
                ></v-select>
              </div>
              <div class="col-md-3 mt-2">
                <label>Sistema</label>
                <v-select
                  v-model="filters.system_error_id"
                  :options="systems"
                  :reduce="(s) => s.id"
                  label="text"
                  placeholder="Selecione"
                ></v-select>
              </div>
              <div class="col-md-3 mt-2">
                <label>Departamento</label>
                <v-select
                  v-model="filters.department_id"
                  :options="departments"
                  :reduce="(d) => d.id"
                  label="text"
                  placeholder="Selecione"
                ></v-select>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-12">
                <button class="btn btn-primary" @click="applyFilters">
                  Filtrar
                </button>
                <button class="btn btn-secondary ml-2" @click="clearFilters">
                  Limpar filtros
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-0 calls-table-card">
          <div class="row" v-if="loading">
            <div class="col-md-12">
              <div class="text-center" style="padding: 50px">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Carregando solicitações...</span>
                </div>
                <p class="mt-2">Carregando solicitações...</p>
              </div>
            </div>
          </div>

          <div v-else class="table-responsive">
            <table
              class="table table-striped table-bordered table-hover calls-table"
            >
              <thead>
                <tr>
                  <th @click="sortBy('id')" class="sortable">
                    Chamado
                    <i class="fas" :class="sortIconClass('id')"></i>
                  </th>
                  <th>SLA / Prazo</th>
                  <th @click="sortBy('status')" class="sortable">
                    Status
                    <i class="fas" :class="sortIconClass('status')"></i>
                  </th>
                  <th>Responsável</th>
                  <th>Prioridade</th>
                  <th style="text-align: left">Última interação</th>
                  <th>Release</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!calls.length">
                  <td colspan="8" class="text-center py-4">
                    Nenhum registro encontrado
                  </td>
                </tr>

                <tr
                  v-for="call in calls"
                  :key="call.id"
                  :class="{ 'info-collapsed': !expandedInfo.includes(call.id) }"
                >
                  <td @click="ticketNewTab(call.id)" style="cursor: pointer">
                    <div class="chamado-top">
                      <div class="chamado-id-date">
                        <span class="chamado-id-chip">#{{ call.id }}</span>
                        <span class="chamado-date">{{
                          call.created_at_f
                        }}</span>
                      </div>
                    </div>
                    <div class="chamado-title-plain">{{ call.title }}</div>
                    <div class="chamado-meta">
                      <span>{{
                        call.user_model ? call.user_model.name : "—"
                      }}</span>
                      <span class="cm-sep">|</span>
                      <span class="cm-sistema">{{
                        call.project ? call.project.name : "—"
                      }}</span>
                      <span class="cm-sep">|</span>
                      <span class="cm-dept">{{
                        call.department ? call.department.name : "—"
                      }}</span>
                    </div>
                    <button
                      type="button"
                      class="btn-info-toggle d-md-none"
                      @click.stop="toggleInfo(call.id)"
                    >
                      <span>Informações</span>
                      <span
                        class="chevron"
                        :class="{ open: expandedInfo.includes(call.id) }"
                        >▾</span
                      >
                    </button>
                  </td>

                  <td data-label="SLA / Prazo">
                    <div class="sla-prazo-cell" :class="slaInfo(call).cls">
                      <div class="sp-left">
                        <span class="sp-label">SLA</span>
                        <span class="sp-sla">{{ slaInfo(call).text }}</span>
                      </div>
                      <div class="sp-right">
                        <span class="sp-label">Prazo</span>
                        <span class="sp-date">{{
                          deadlineInfo(call).text
                        }}</span>
                      </div>
                    </div>
                  </td>

                  <td class="text-center" data-label="Status">
                    <span
                      class="soft-badge"
                      :class="
                        call.status_calls
                          ? call.status_calls.badge_description
                          : ''
                      "
                    >
                      {{
                        call.status_calls ? call.status_calls.description : "—"
                      }}
                    </span>
                  </td>

                  <td class="text-center" data-label="Responsável">
                    <div v-if="!call.dev || !call.dev.name">—</div>
                    <div v-else>{{ devName(call) }}</div>
                  </td>

                  <td class="text-center" data-label="Prioridade">
                    {{
                      ["🔴", "🟡", "🟢", "🔵"].includes(call.priority)
                        ? call.priority
                        : "—"
                    }}
                  </td>

                  <td style="text-align: center" data-label="Última interação">
                    <div v-if="!call.last_interaction_user_name">—</div>
                    <div v-else class="li-cell">
                      <span class="li-name">{{
                        call.last_interaction_user_name
                      }}</span>
                      <div class="li-date" v-if="call.last_interaction_date">
                        {{ call.last_interaction_date }}
                      </div>
                    </div>
                  </td>

                  <td data-label="Release">
                    <div
                      v-if="!call.release"
                      style="
                        color: rgba(255, 255, 255, 0.3);
                        font-size: 13px;
                        text-align: center;
                      "
                    >
                      —
                    </div>
                    <div
                      v-else-if="isAdmin"
                      class="release-cell"
                      style="cursor: pointer"
                      title="Ver chamados desta release"
                      @click="openReleaseTickets(call.release)"
                    >
                      <div class="release-version">
                        {{ call.release.version_string }}
                      </div>
                      <div class="release-name">{{ call.release.name }}</div>
                    </div>
                    <div v-else class="release-cell">
                      <div class="release-version">
                        {{ call.release.version_string }}
                      </div>
                      <div class="release-name">{{ call.release.name }}</div>
                    </div>
                  </td>

                  <td data-label="Ações">
                    <button
                      data-toggle="tooltip"
                      title="Atender Chamado"
                      class="btn btn-crud edit margin-crud"
                      @click="ticketNewTab(call.id)"
                      style="cursor: pointer"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                    <button
                      v-if="isAdmin"
                      title="Vincular/Desvincular Release"
                      class="btn btn-crud view margin-crud"
                      @click="openReleaseModal({ row: call })"
                    >
                      <i class="fas fa-code-branch"></i>
                    </button>
                    <button
                      v-if="$store.state.user.perfil_id != 20"
                      title="Deletar"
                      class="btn btn-crud delete margin-crud"
                      data-toggle="modal"
                      data-target="#deletewithreasons"
                      @click="selectLine(call)"
                    >
                      <i class="far fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="pagination-bar">
            <div class="per-page-selector">
              Registros por página:
              <select
                class="form-control d-inline-block w-auto ml-1"
                v-model.number="pagination.perPage"
                @change="changePerPage"
              >
                <option
                  v-for="v in pagination.perPageOptions"
                  :key="v"
                  :value="v"
                >
                  {{ v }}
                </option>
              </select>
            </div>

            <div
              class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
            >
              <pagination
                :records="totalChamados"
                :options="paginationOptions"
                :per-page="pagination.perPage"
                @paginate="onPaginate"
              ></pagination>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div
      class="modal fade"
      id="deletewithreasons"
      tabindex="-1"
      role="dialog"
      aria-labelledby="title"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="title">
              Escolha o motivo para Excluir!
            </h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label>Selecione o novo status</label>
                <v-select
                  v-model="reason"
                  :options="reasons"
                  :reduce="(reasons) => reasons.id"
                  :label="'title'"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="deleteWithReason()"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Chamados da Release -->
    <release-tickets-modal ref="releaseTicketsModal"></release-tickets-modal>

    <!-- Modal: Vincular Release -->
    <div
      class="modal fade"
      id="releaseModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="releaseModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="releaseModalLabel">
              Release — Chamado #{{
                releaseModalTicket ? releaseModalTicket.id : ""
              }}
            </h5>
            <button type="button" class="close" data-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="releaseModalTicket && releaseModalTicket.release_id">
              <p>
                Chamado atualmente vinculado a:
                <strong class="text-primary">
                  {{
                    releaseModalTicket.release
                      ? releaseModalTicket.release.version_string +
                        " — " +
                        releaseModalTicket.release.name
                      : "uma release"
                  }}
                </strong>
              </p>
              <button
                class="btn btn-danger btn-sm"
                @click="detachRelease"
                :disabled="savingRelease"
              >
                <i class="fas fa-unlink mr-1"></i>
                {{ savingRelease ? "Removendo..." : "Remover da release" }}
              </button>
            </div>
            <div v-else>
              <div class="form-group">
                <label>Selecionar Release</label>
                <v-select
                  v-model="selectedReleaseId"
                  :options="modalReleases"
                  :reduce="(r) => r.id"
                  label="release_label"
                  placeholder="Selecione uma release..."
                ></v-select>
              </div>
              <small class="text-muted" v-if="!modalReleases.length">
                Nenhuma release disponível para o sistema deste chamado.
              </small>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button
              v-if="releaseModalTicket && !releaseModalTicket.release_id"
              type="button"
              class="btn btn-primary"
              @click="attachRelease"
              :disabled="savingRelease || !selectedReleaseId"
            >
              <i class="fas fa-link mr-1"></i>
              {{ savingRelease ? "Vinculando..." : "Vincular" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
import ReleaseTicketsModal from "../../components/ReleaseTicketsModal";

export default {
  components: {
    Pagination,
    ReleaseTicketsModal,
  },
  data: function () {
    return {
      endPoint: "calls/",
      filters: {
        id: "",
        title: "",
        status: null,
        user_id: null,
        dev_acting: null,
        priority: null,
        system_error_id: null,
        department_id: null,
      },
      expandedInfo: [],
      filtersOpen: false,
      loading: false,
      pageLoading: true,
      users: [],
      systems: [],
      departments: [],
      status_calls: [],
      priorityOptions: [
        { id: "🔵", text: "🔵 Ultra baixa prioridade" },
        { id: "🟢", text: "🟢 Baixa prioridade" },
        { id: "🟡", text: "🟡 Média prioridade" },
        { id: "🔴", text: "🔴 Alta prioridade" },
      ],

      calls: [],
      totalChamados: 0,
      pagination: {
        page: 1,
        perPage: 10,
        perPageOptions: [10, 25, 50, 100],
      },
      paginationOptions: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      sort: {
        column: "id",
        ascending: false,
      },

      reasons: [],
      reason: null,
      lineClick: null,

      releaseModalTicket: null,
      modalReleases: [],
      selectedReleaseId: null,
      savingRelease: false,

      kpis: {},
      kpiFilters: [],
    };
  },

  computed: {
    isAdmin() {
      return this.$store.state.user.perfil_id === 8;
    },
  },

  watch: {
    isAdmin: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getKpis();
        }
      },
    },
  },

  async mounted() {
    this.pageLoading = true;

    try {
      await Promise.all([
        this.getStatusCalls(),
        this.getUsers(),
        this.getSystems(),
        this.getDepartments(),
      ]);

      await this.fetchCalls();
    } catch (e) {
      console.error(e);
    } finally {
      this.pageLoading = false;
    }
  },

  methods: {
    fetchCalls() {
      const self = this;
      const f = this.filters;

      const body = {
        exclude_status: "9,12",
        paginated: true,
        page: this.pagination.page,
        limit: this.pagination.perPage,
        with: [
          "dev",
          "status_calls",
          "user_model",
          "project",
          "department",
          "release",
        ],
      };

      if (this.sort.ascending) {
        body.orderByAsc = this.sort.column;
      } else {
        body.orderByDesc = this.sort.column;
      }

      if (f.id) body.id = f.id;
      if (f.title) body.title = f.title;
      if (f.status) body.status = f.status;
      if (f.user_id) body.user_id = f.user_id;
      if (f.dev_acting) body.dev_acting = f.dev_acting;
      if (f.priority !== null && f.priority !== undefined)
        body.priority = f.priority;
      if (f.system_error_id) body.system_error_id = f.system_error_id;
      if (f.department_id) body.department_id = f.department_id;

      //  Filtros dos KPIs (cards do topo) — selecionar mais de um KPI ao mesmo tempo
      const typeCalls = [];
      this.kpiFilters.forEach((kpi) => {
        if (kpi === "aguardando") body.kpi_status = 1;
        if (kpi === "com_release") body.with_release = 1;
        if (kpi === "sem_release") body.without_release = 1;
        if (kpi === "tipo_erro") typeCalls.push(1);
        if (kpi === "tipo_melhoria") typeCalls.push(2);
      });

      if (typeCalls.length === 1) {
        body.type_call_id = typeCalls[0];
      } else if (typeCalls.length > 1) {
        body.type_call_id = typeCalls;
      }

      self.loading = true;
      return axios
        .post(self.$store.state.api + "calls-list", body)
        .then((response) => {
          self.calls = response.data.data;
          self.totalChamados = response.data.count;
          self.loading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.loading = false;
        });
    },

    toggleInfo(id) {
      const i = this.expandedInfo.indexOf(id);
      if (i === -1) this.expandedInfo.push(id);
      else this.expandedInfo.splice(i, 1);
    },

    applyFilters() {
      this.pagination.page = 1;
      this.fetchCalls();
    },

    clearFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = key === "title" || key === "id" ? "" : null;
      });
      this.applyFilters();
    },

    onPaginate(page) {
      this.pagination.page = page;
      this.fetchCalls();
    },

    changePerPage() {
      this.pagination.page = 1;
      this.fetchCalls();
    },

    sortBy(column) {
      if (this.sort.column === column) {
        this.sort.ascending = !this.sort.ascending;
      } else {
        this.sort.column = column;
        this.sort.ascending = true;
      }
      this.fetchCalls();
    },

    sortIconClass(column) {
      if (this.sort.column !== column) return "fa-sort";
      return this.sort.ascending ? "fa-chevron-up" : "fa-chevron-down";
    },

    devName(call) {
      if (call.status === 9) return "Cancelado";
      return call.dev ? call.dev.name : "-";
    },

    slaInfo(call) {
      if (!call.deadline) return { cls: "badge-secondary", text: "Sem SLA" };

      const deadline = new Date(call.deadline);
      const today = new Date();
      deadline.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      const diffDays = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));
      let cls = "badge-success";
      if (diffDays === 2 || diffDays === 1) cls = "badge-warning";
      else if (diffDays <= 0) cls = "badge-danger";

      let text = (call.sla && call.sla.text) || call.deadline_f;
      if (text && text.indexOf(":") !== -1) {
        text = text.slice(text.indexOf(":") + 1).trim();
      }

      return { cls, text };
    },

    deadlineInfo(call) {
      if (!call.deadline) return { cls: "badge-secondary", text: "Sem prazo" };

      const deadline = new Date(call.deadline);
      const today = new Date();
      deadline.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      const diffDays = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));
      let cls = "badge-success";
      if (diffDays === 2 || diffDays === 1) cls = "badge-warning";
      else if (diffDays <= 0) cls = "badge-danger";

      return { cls, text: call.deadline_f };
    },

    ticket(id) {
      this.$router.push({ path: this.endPoint + "ticket/" + id });
    },

    ticketNewTab(id) {
      const route = this.$router.resolve({
        path: this.endPoint + "ticket/" + id,
      });
      window.open(route.href, "_blank");
    },

    getKpis() {
      const self = this;
      return axios
        .get(self.$store.state.api + "calls-kpi")
        .then((res) => {
          self.kpis = res.data;
        })
        .catch(() => {});
    },

    toggleKpiFilter(key) {
      const i = this.kpiFilters.indexOf(key);

      if (i === -1) {
        if (key === "com_release") {
          const j = this.kpiFilters.indexOf("sem_release");
          if (j !== -1) this.kpiFilters.splice(j, 1);
        }
        if (key === "sem_release") {
          const j = this.kpiFilters.indexOf("com_release");
          if (j !== -1) this.kpiFilters.splice(j, 1);
        }
        this.kpiFilters.push(key);
      } else {
        this.kpiFilters.splice(i, 1);
      }

      this.pagination.page = 1;
      this.fetchCalls();
    },

    clearKpis() {
      this.kpiFilters = [];
      this.pagination.page = 1;
      this.fetchCalls();
    },

    openReleaseTickets(release) {
      this.$refs.releaseTicketsModal.open(release);
    },

    openReleaseModal(payload) {
      const ticket = payload.row;
      this.releaseModalTicket = ticket;
      this.selectedReleaseId = null;
      this.modalReleases = [];

      if (ticket.system_error_id) {
        axios
          .get(
            this.$store.state.api +
              `releases?project_id=${ticket.system_error_id}&paginated=false&status=planejada`
          )
          .then((res) => {
            const data = res.data.data || res.data;
            this.modalReleases = data.map((r) => ({
              ...r,
              release_label: `${r.version_string} — ${r.name} (${r.status})`,
            }));
          })
          .catch(() => {});
      }

      $("#releaseModal").modal("show");
    },

    attachRelease() {
      if (!this.selectedReleaseId || !this.releaseModalTicket) return;
      this.savingRelease = true;
      axios
        .post(this.$store.state.api + "releases/attach-ticket", {
          ticket_id: this.releaseModalTicket.id,
          release_id: this.selectedReleaseId,
        })
        .then(() => {
          this.$message("Sucesso", "Chamado vinculado à release!", "success");
          $("#releaseModal").modal("hide");
          this.fetchCalls();
        })
        .catch(() => {
          this.$message("Erro", "Não foi possível vincular.", "error");
        })
        .finally(() => {
          this.savingRelease = false;
        });
    },

    detachRelease() {
      if (!this.releaseModalTicket) return;
      this.savingRelease = true;
      axios
        .delete(
          this.$store.state.api +
            `releases/detach-ticket/${this.releaseModalTicket.id}`
        )
        .then(() => {
          this.$message(
            "Sucesso",
            "Chamado desvinculado da release!",
            "success"
          );
          $("#releaseModal").modal("hide");
          this.fetchCalls();
        })
        .catch(() => {
          this.$message("Erro", "Não foi possível desvincular.", "error");
        })
        .finally(() => {
          this.savingRelease = false;
        });
    },

    selectLine(call) {
      this.lineClick = call.id;
    },

    getReasons() {
      const self = this;
      const api = self.$store.state.api + "reasons_delete_" + self.endPoint;
      axios
        .get(api)
        .then((response) => {
          self.reasons = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    deleteWithReason() {
      const self = this;
      if (!self.reason) {
        swal("Erro", "Selecione um motivo para excluir!", "error");
        return false;
      }
      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: { text: "Não", value: "cancel", className: "btn-danger" },
          confirm: { text: "Sim", value: "confirm" },
        },
      }).then((value) => {
        if (value !== "confirm") {
          swal("Cancelado", "O registro não foi excluido!", "info");
          return;
        }

        const api =
          self.$store.state.api + "log_reasons_delete_" + self.endPoint;
        axios
          .post(api, {
            id_calls: self.lineClick,
            id_reasons_delete: self.reason,
          })
          .then(() => {
            swal("Sucesso", "Registro excluído com sucesso!", "success");
            self.fetchCalls();
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      });
    },

    getStatusCalls() {
      const self = this;
      const api = self.$store.state.api + "statusCall?paginated=false";
      return axios
        .get(api)
        .then((response) => {
          self.status_calls = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getUsers() {
      const self = this;
      const api = self.$store.state.api + "users?paginated=false";
      return axios
        .get(api)
        .then((response) => {
          self.users = response.data.data.map((user) => ({
            id: user.id,
            text: user.name,
          }));
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getSystems() {
      const self = this;
      const api = self.$store.state.api + "projects?paginated=false";
      return axios
        .get(api)
        .then((response) => {
          self.systems = response.data.data.map((system) => ({
            id: system.id,
            text: system.name,
          }));
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getDepartments() {
      const self = this;
      const api = self.$store.state.api + "departments";
      return axios
        .get(api)
        .then((response) => {
          self.departments = response.data.data.map((department) => ({
            id: department.id,
            text: department.name,
          }));
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },

  created() {
    this.getReasons();
  },
};
</script>

<style scoped>
.kpi-card {
  transition: box-shadow 0.15s, border-color 0.15s;
  border: 2px solid transparent;
}
.kpi-card:hover {
  box-shadow: 0 0 0 2px rgba(115, 103, 240, 0.4);
}
.kpi-active {
  border-color: #7367f0 !important;
  box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.25);
}

.calls-table {
  margin-bottom: 0;
  font-size: 0.95rem;
}

.calls-table thead th.sortable {
  cursor: pointer;
  user-select: none;
}

.calls-table td,
.calls-table th {
  padding: 0.9rem 0.75rem;
}

.calls-table thead th {
  background-color: #283046 !important;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  vertical-align: middle;
  border-left: none !important;
  border-right: none !important;
}

.calls-table tbody tr,
.calls-table tbody tr:nth-of-type(odd),
.calls-table tbody tr:nth-of-type(even) {
  background-color: #132133 !important;
}

.calls-table tbody td {
  background-color: #132133 !important;
}

.calls-table .badge {
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.5em 0.8em;
  display: inline-block;
  white-space: nowrap;
}

.calls-table .soft-badge {
  display: inline-block;
  white-space: normal;
  max-width: 140px;
  padding: 0.5em 0.75em;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.2;
  border-radius: 6px;
  border: 1px solid transparent;
}

.calls-table .soft-badge.badge-danger {
  background-color: rgba(234, 84, 85, 0.12) !important;
  border-color: rgba(234, 84, 85, 0.4);
  color: #d97577 !important;
}

.calls-table .soft-badge.badge-warning {
  background-color: rgba(255, 159, 67, 0.12) !important;
  border-color: rgba(255, 159, 67, 0.4);
  color: #d99a5c !important;
}

.calls-table .soft-badge.badge-success {
  background-color: rgba(40, 199, 111, 0.12) !important;
  border-color: rgba(40, 199, 111, 0.4);
  color: #5cb98a !important;
}

.calls-table .soft-badge.badge-primary {
  background-color: rgba(115, 103, 240, 0.12) !important;
  border-color: rgba(115, 103, 240, 0.4);
  color: #8b82df !important;
}

.calls-table .soft-badge.badge-secondary {
  background-color: rgba(130, 134, 139, 0.12) !important;
  border-color: rgba(130, 134, 139, 0.4);
  color: #a9adb3 !important;
}

.calls-table .soft-badge.badge-info {
  background-color: rgba(0, 207, 232, 0.12) !important;
  border-color: rgba(0, 207, 232, 0.4);
  color: #5cc4d4 !important;
}

.calls-table .soft-badge.prazo-badge {
  background-color: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.25);
  color: #a9adb3 !important;
}

.calls-table td:last-child {
  text-align: center;
  white-space: nowrap;
}

.calls-table td:last-child .btn {
  display: block;
  margin: 4px auto;
}

.calls-table tbody td:nth-child(7) {
  text-align: center;
}

.pagination-bar {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 16px;
  position: relative;
}

.pagination-bar .per-page-selector {
  position: absolute;
  left: 16px;
  top: 16px;
  display: flex;
  align-items: center;
  height: 38px;
}

.pagination-bar ::v-deep .VuePagination {
  text-align: center;
  margin-bottom: 0;
}

.pagination-bar ::v-deep .VuePagination ul.pagination {
  margin-bottom: 0;
  justify-content: center;
}

.pagination-bar ::v-deep .VuePagination__count {
  margin: 8px 0 0;
}

.key {
  border: 2px solid #ff7301;
  color: #000000;
}

.key:hover {
  background: #ff7301 !important;
  color: #ffffff;
}

.margin-crud {
  margin: 0 2px;
}

.call-page-container {
  border-radius: 8px;
  padding: 20px;
  position: relative;
  z-index: 1;
}

.call-filters,
.calls-table-card {
  background: rgba(23, 38, 57, 0.55) !important;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}
.call-filters {
  position: relative;
  z-index: 20;
}

.calls-table-card {
  position: relative;
  z-index: 1;
  border-radius: 6px;
  overflow: hidden;
}

.sla-prazo-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px 8px 10px;
  border-left: 4px solid rgba(130, 134, 139, 0.5);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.03);
}
.sla-prazo-cell.badge-danger {
  border-left-color: #ea5455;
}
.sla-prazo-cell.badge-warning {
  border-left-color: #ff9f43;
}
.sla-prazo-cell.badge-success {
  border-left-color: #28c76f;
}

.sp-left,
.sp-right {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.sp-right {
  text-align: right;
}

.sp-label {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.4);
}

.sp-sla {
  font-size: 0.9rem;
  font-weight: 700;
  color: #a9adb3;
}
.sla-prazo-cell.badge-danger .sp-sla {
  color: #d97577;
}
.sla-prazo-cell.badge-warning .sp-sla {
  color: #d99a5c;
}
.sla-prazo-cell.badge-success .sp-sla {
  color: #5cb98a;
}
.sp-date {
  font-size: 0.82rem;
  font-weight: 600;
  color: #ffffffbd;
}

.chamado-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 9px;
  margin-bottom: 12px;
}
.chamado-id-date {
  display: flex;
  align-items: center;
  gap: 9px;
}
.chamado-dept {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  flex: none;
}
.chamado-id-chip {
  font: 0.91rem ui-monospace, Menlo, monospace;
  padding: 3px 8px;
  border-radius: 6px;
  background: #82868b6e;
  border: 1px solid #82868b;
  color: #ffffffbd;
}
.chamado-date {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.4);
}
.chamado-title-plain {
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.35;
  color: #ffffffbd;
  margin-bottom: 12px;
}
.chamado-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  row-gap: 6px;
  margin-top: 12px;
  font-size: 0.75rem;
  color: #c9d4e8;
  flex-wrap: wrap;
}

.chamado-meta .cm-sep {
  color: rgba(255, 255, 255, 0.25);
}
.chamado-meta .cm-sistema {
  color: rgba(255, 255, 255, 0.55);
}
.chamado-meta .cm-dept {
  color: rgba(255, 255, 255, 0.4);
}
.chamado-meta .cm-date {
  color: rgba(255, 255, 255, 0.4);
  overflow: hidden;
  text-overflow: ellipsis;
}

.li-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
.li-name {
  font-size: 0.8rem;
  font-weight: 700;
  color: #ffffffbd;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 210px;
}
.li-date {
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.45);
}

.release-cell {
  padding: 16px 20px;
  border-left: 3px solid #3b82f6;
}
.release-version {
  font: 700 13px ui-monospace, Menlo, monospace;
  color: #6ea8fe;
}
.release-name {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 3px;
}

.kpi-disabled {
  opacity: 0.4;
  cursor: not-allowed !important;
  pointer-events: none;
}

.btn-filters-toggle {
  display: none;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border: none;
  color: inherit;
  font-weight: 600;
  font-size: 14px;
  padding: 14px 16px;
  cursor: pointer;
}
.btn-filters-toggle .chevron {
  transition: transform 0.15s;
  color: rgba(255, 255, 255, 0.5);
}
.btn-filters-toggle .chevron.open {
  transform: rotate(180deg);
}

/* LIGHT MODE */

body:not(.dark-layout) .call-filters,
body:not(.dark-layout) .calls-table-card {
  background: rgba(255, 255, 255, 0.55) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

body:not(.dark-layout) .calls-table thead th {
  background-color: rgba(255, 255, 255, 0.45) !important;
}

body:not(.dark-layout) .calls-table tbody tr,
body:not(.dark-layout) .calls-table tbody tr:nth-of-type(odd),
body:not(.dark-layout) .calls-table tbody tr:nth-of-type(even),
body:not(.dark-layout) .calls-table tbody td {
  background-color: rgba(255, 255, 255, 0.35) !important;
}

body:not(.dark-layout) .li-name,
body:not(.dark-layout) .chamado-title-plain,
body:not(.dark-layout) .sp-date,
body:not(.dark-layout) .chamado-id-chip {
  color: #5e5873;
}

body:not(.dark-layout) .li-date,
body:not(.dark-layout) .chamado-date,
body:not(.dark-layout) .sp-label,
body:not(.dark-layout) .chamado-meta .cm-date,
body:not(.dark-layout) .release-name {
  color: rgba(0, 0, 0, 0.45);
}
body:not(.dark-layout) .chamado-meta .cm-sep {
  color: rgba(0, 0, 0, 0.25);
}

body:not(.dark-layout) .chamado-id-chip {
  background: rgba(66, 101, 255, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.15);
}

body:not(.dark-layout) .sla-prazo-cell {
  background: rgba(0, 0, 0, 0.03);
}
body:not(.dark-layout) .sp-sla {
  color: #6e6b7b;
}
body:not(.dark-layout) .sla-prazo-cell.badge-danger .sp-sla {
  color: #ea5455;
}
body:not(.dark-layout) .sla-prazo-cell.badge-warning .sp-sla {
  color: #ff9f43;
}
body:not(.dark-layout) .sla-prazo-cell.badge-success .sp-sla {
  color: #28c76f;
}

body:not(.dark-layout) .calls-table .soft-badge.badge-danger {
  color: #ea5455 !important;
}
body:not(.dark-layout) .calls-table .soft-badge.badge-warning {
  color: #ff9f43 !important;
}
body:not(.dark-layout) .calls-table .soft-badge.badge-success {
  color: #28c76f !important;
}
body:not(.dark-layout) .calls-table .soft-badge.badge-primary {
  color: #7367f0 !important;
}
body:not(.dark-layout) .calls-table .soft-badge.badge-secondary {
  color: #82868b !important;
}
body:not(.dark-layout) .calls-table .soft-badge.badge-info {
  color: #00cfe8 !important;
}
body:not(.dark-layout) .calls-table .soft-badge.prazo-badge {
  background-color: rgba(0, 0, 0, 0.05) !important;
  border-color: rgba(0, 0, 0, 0.15);
  color: #6e6b7b !important;
}

body:not(.dark-layout) .release-version {
  color: #4265ff;
}

body:not(.dark-layout) {
  background: rgba(66, 101, 255, 0.15);
  color: #4265ff;
}
body:not(.dark-layout) .chamado-meta {
  color: #5e5873;
}
body:not(.dark-layout) .chamado-meta .cm-sistema {
  color: rgba(0, 0, 0, 0.55);
}
body:not(.dark-layout) .chamado-meta .cm-dept {
  color: rgba(0, 0, 0, 0.45);
}

/* RESPONSIVO — tabela cabe em qualquer notebook sem scroll horizontal */
.calls-table {
  width: 100%;
  table-layout: fixed;
}

.calls-table th,
.calls-table td {
  white-space: normal;
  overflow-wrap: break-word;
}

.calls-table thead th {
  font-size: 0.8rem;
}

.calls-table th:nth-child(1) {
  width: 25%;
} /* Chamado */
.calls-table th:nth-child(2) {
  width: 16%;
} /* SLA / Prazo */
.calls-table th:nth-child(3) {
  width: 12%;
} /* Status */
.calls-table th:nth-child(4) {
  width: 12%;
} /* Responsável */
.calls-table th:nth-child(5) {
  width: 10%;
} /* Prioridade */
.calls-table th:nth-child(6) {
  width: 11%;
} /* Última interação */
.calls-table th:nth-child(7) {
  width: 10%;
} /* Release */
.calls-table th:nth-child(8) {
  width: 6%;
} /* Ações */

.li-name {
  max-width: 100%;
}

/* RESPONSIVO — PARA TELAS MOBILE */

@media (max-width: 768px) {
  .btn-filters-toggle {
    display: flex;
  }
  .call-filters .card-body {
    display: none;
  }
  .call-filters .card-body.card-body-mobile-open {
    display: block;
    padding-top: 0;
  }

  .kpi-card .text-muted {
    word-break: keep-all;
    overflow-wrap: normal;
    hyphens: none;
    white-space: normal;
    line-height: 1.3;
  }

  .calls-table thead {
    display: none;
  }
  .calls-table,
  .calls-table tbody,
  .calls-table tr,
  .calls-table td {
    display: block;
    width: 100% !important;
  }
  .calls-table tr {
    margin-bottom: 14px;
    border-radius: 8px;
    padding: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
  }

  .calls-table td[data-label]:not(:first-child)::before {
    content: attr(data-label);
    display: block;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.45);
    margin-bottom: 4px;
  }
  .calls-table td[data-label]:not(:first-child) {
    text-align: left !important;
  }

  .calls-table td[data-label="SLA / Prazo"]::before {
    display: none;
  }

  .chamado-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .chamado-meta .cm-sep {
    display: none;
  }

  /* .chamado-id-chip {
    border-radius: 10px;
  }

  .btn-info-toggle {
    border-radius: 8px;
  } */

  .calls-table td:last-child .btn {
    display: inline-block;
    margin: 4px 6px 0 0;
  }
  .li-name {
    max-width: none;
  }

  body:not(.dark-layout) .calls-table td[data-label]:not(:first-child)::before {
    color: rgba(0, 0, 0, 0.45);
  }

  .btn-info-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.55);
    font-weight: 600;
    font-size: 12px;
    padding: 8px 0 0;
    margin-top: 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    cursor: pointer;
  }
  .btn-info-toggle .chevron {
    transition: transform 0.15s;
  }
  .btn-info-toggle .chevron.open {
    transform: rotate(180deg);
  }

  .calls-table tr.info-collapsed td:not(:first-child) {
    display: none;
  }

  .pagination-bar {
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding-top: 5px;
  }
  .pagination-bar .per-page-selector {
    position: static;
    justify-content: center;
    width: 100%;
  }
  .pagination-bar ::v-deep .VuePagination__count {
    font-size: 12px;
    text-align: center;
  }

  .call-filters .row.mt-3 > .col-md-12 {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
  }
  .call-filters .row.mt-3 .btn {
    flex: 1 1 0;
    margin-left: 0 !important;
    white-space: nowrap;
  }
}
</style>
